import React from "react";
import {
  FaFileContract,
  FaShieldAlt,
  FaCheckCircle,
  FaCreditCard,
  FaUndo,
  FaUserCheck,
  FaGavel,
  FaEnvelope,
} from "react-icons/fa";

const TermsConditions = () => {
  return (
    <div
      style={{
        fontFamily: "'Inter', 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
        background: "linear-gradient(135deg, #F5F5F5 0%, #FFFFFF 100%)",
        minHeight: "100vh",
        paddingBottom: "40px",
      }}
    >
      {/* Enhanced Header */}
      <header
        style={{
          background: "linear-gradient(135deg, #EE2E24 0%, #FFC400 100%)",
          color: "#fff",
          padding: "50px 20px 35px 20px",
          textAlign: "center",
          position: "relative",
          overflow: "hidden",
        }}
      >
        {/* Decorative Circles */}
        <div
          style={{
            position: "absolute",
            top: "-50px",
            right: "-50px",
            width: "200px",
            height: "200px",
            borderRadius: "50%",
            background: "rgba(255, 255, 255, 0.1)",
          }}
        />
        <div
          style={{
            position: "absolute",
            bottom: "-30px",
            left: "-30px",
            width: "150px",
            height: "150px",
            borderRadius: "50%",
            background: "rgba(255, 255, 255, 0.1)",
          }}
        />

        <div
          style={{
            position: "relative",
            zIndex: 1,
            maxWidth: "800px",
            margin: "0 auto",
          }}
        >
          <div
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "8px",
              background: "rgba(255, 255, 255, 0.2)",
              padding: "6px 16px",
              borderRadius: "20px",
              marginBottom: "16px",
              fontSize: "0.85rem",
              fontWeight: "600",
            }}
          >
            <FaFileContract style={{ fontSize: "0.9rem" }} />
            Trivana Hospitality
          </div>

          <h1
            style={{
              fontSize: "2.5rem",
              fontWeight: "800",
              marginBottom: "12px",
              letterSpacing: "-0.8px",
              textShadow: "0 2px 10px rgba(0,0,0,0.1)",
            }}
          >
            Terms &amp; Conditions
          </h1>

          <p
            style={{
              fontSize: "1rem",
              opacity: 0.95,
              fontWeight: "500",
              maxWidth: "700px",
              margin: "0 auto 12px auto",
              lineHeight: "1.6",
            }}
          >
            Please read these Terms &amp; Conditions carefully before using our
            site or services. By using Booktrivana (operated by Trivana
            Hospitality), you agree to these terms.
          </p>

          <div
            style={{
              fontSize: "0.85rem",
              opacity: 0.9,
              fontWeight: "500",
            }}
          >
            Effective date: September 5, 2025
          </div>
        </div>
      </header>

      <div style={{ maxWidth: "1000px", margin: "0 auto", padding: "0 20px" }}>
        {/* Table of Contents */}
        <nav
          style={{
            background: "#FFFFFF",
            padding: "24px",
            borderRadius: "14px",
            margin: "35px 0",
            border: "1px solid rgba(238, 46, 36, 0.1)",
            boxShadow: "0 4px 15px rgba(0,0,0,0.06)",
          }}
        >
          <h2
            style={{
              fontSize: "1.1rem",
              fontWeight: "800",
              color: "#2E2E2E",
              marginBottom: "16px",
              letterSpacing: "-0.5px",
            }}
          >
            Table of Contents
          </h2>
          <ul
            style={{
              listStyle: "none",
              padding: 0,
              margin: 0,
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
              gap: "10px",
            }}
          >
            {[
              { id: "introduction", title: "1. Introduction" },
              { id: "definitions", title: "2. Definitions" },
              { id: "bookings", title: "3. Bookings & Reservations" },
              { id: "payments", title: "4. Payments & Pricing" },
              { id: "cancellations", title: "5. Cancellations & Refunds" },
              { id: "checkin", title: "6. Check-in, Check-out & No-shows" },
              {
                id: "user-responsibilities",
                title: "7. User Responsibilities",
              },
              { id: "changes-providers", title: "8. Changes by Providers" },
              { id: "liability", title: "9. Liability & Indemnity" },
              { id: "privacy", title: "10. Privacy & Data" },
              { id: "governing-law", title: "11. Governing Law & Disputes" },
              { id: "contact", title: "12. Contact" },
            ].map((item, index) => (
              <li key={index}>
                <a
                  href={`#${item.id}`}
                  style={{
                    color: "#2E2E2E",
                    textDecoration: "none",
                    fontSize: "0.9rem",
                    fontWeight: "600",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    padding: "8px 12px",
                    borderRadius: "8px",
                    transition: "all 0.3s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.background =
                      "linear-gradient(135deg, rgba(238, 46, 36, 0.08) 0%, rgba(255, 196, 0, 0.08) 100%)";
                    e.target.style.transform = "translateX(5px)";
                    e.target.style.color = "#EE2E24";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.background = "transparent";
                    e.target.style.transform = "translateX(0)";
                    e.target.style.color = "#2E2E2E";
                  }}
                >
                  <FaCheckCircle
                    style={{ fontSize: "0.75rem", color: "#EE2E24" }}
                  />
                  {item.title}
                </a>
              </li>
            ))}
          </ul>
        </nav>

        {/* --- Sections --- */}
        <section
          id="introduction"
          className="card p-4 mb-4 shadow-sm animate-fade"
        >
          <div className="d-flex align-items-center mb-2">
            <span className="section-accent me-3"></span>
            <h2 className="card-title h4 mb-0 fw-bold">1. Introduction</h2>
          </div>
          <p className="text-dark text-start">
            These Terms &amp; Conditions (the “Terms”) govern your access to and
            use of Booktrivana (the “Website”) and any services offered by
            Trivana Hospitality (“we”, “us”, “our”). By accessing or using our
            Website, mobile app, or booking services, you agree to be bound by
            these Terms and by our{" "}
            <strong>
              <a href="/privacy-policy" className="contact-link">
                Privacy Policy
              </a>
            </strong>
            . If you do not agree to these Terms, please do not use our
            services.
          </p>
        </section>

        <section
          id="definitions"
          className="card p-4 mb-4 shadow-sm animate-fade"
        >
          <div className="d-flex align-items-center mb-2">
            <span className="section-accent me-3"></span>
            <h2 className="card-title h4 mb-0 fw-bold">2. Definitions</h2>
          </div>
          <ul className="mt-2 text-dark text-start">
            <li>
              <strong>“User”</strong> means any person using our Website or
              Services.
            </li>
            <li>
              <strong>“Provider”</strong> means the hotel, restaurant, host or
              third party supplying the service you book via our platform.
            </li>
            <li>
              <strong>“Booking”</strong> means a confirmed reservation made
              through Booktrivana.
            </li>
          </ul>
        </section>

        <section id="bookings" className="card p-4 mb-4 shadow-sm animate-fade">
          <div className="d-flex align-items-center mb-2">
            <span className="section-accent me-3"></span>
            <h2 className="card-title h4 mb-0 fw-bold">
              3. Bookings &amp; Reservations
            </h2>
          </div>
          <p className="text-dark text-start">
            All bookings are subject to availability and the terms and policies
            of the relevant Provider. When you make a reservation through
            Booktrivana, you are entering into a contract with that Provider
            and, where applicable, with Trivana Hospitality for facilitation of
            the booking. We will confirm bookings by email or SMS once the
            Provider has accepted your reservation.
          </p>
          <div className="row mt-3 g-3">
            <div className="col-12 col-lg-6">
              <h5 className="fw-bold text-dark text-start">
                Confirmation & Vouchers
              </h5>
              <p className="mt-2 text-dark text-start">
                After successful payment (if applicable), you will receive a
                booking confirmation or voucher which you should present at
                check-in or on arrival as required by the Provider.
              </p>
            </div>
            <div className="col-12 col-lg-6">
              <h5 className="fw-bold text-dark text-start">Special Requests</h5>
              <p className="mt-2 text-dark text-start">
                Special requests (e.g. late check-in, extra bed) are requests
                only; they are not guaranteed unless confirmed by the Provider.
              </p>
            </div>
          </div>
        </section>

        <section id="payments" className="card p-4 mb-4 shadow-sm animate-fade">
          <div className="d-flex align-items-center mb-2">
            <span className="section-accent me-3"></span>
            <h2 className="card-title h4 mb-0 fw-bold">
              4. Payments, Pricing &amp; Fees
            </h2>
          </div>
          <p className="text-dark text-start">
            Prices shown on the Website are provided by Providers and may
            change. All prices are subject to availability and may include local
            taxes and fees. Payment methods are processed through secure
            third-party payment gateways. By providing payment information, you
            authorize us (or our payment providers) to charge the selected card
            or payment method for the booking amount and any applicable fees.
          </p>
          <p className="mt-2 text-dark text-start">
            If a payment fails or is disputed, we reserve the right to cancel
            pending reservations and take appropriate measures to protect Users
            and Providers.
          </p>
        </section>

        <section
          id="cancellations"
          className="card p-4 mb-4 shadow-sm animate-fade"
        >
          <div className="d-flex align-items-center mb-2">
            <span className="section-accent me-3"></span>
            <h2 className="card-title h4 mb-0 fw-bold">
              5. Cancellations &amp; Refunds
            </h2>
          </div>
          <p className="text-dark text-start">
            Cancellation and refund policies vary by Provider and by the rate
            selected at the time of booking. Some rates are non-refundable.
            Please review the Provider’s cancellation policy shown on your
            booking confirmation before completing your reservation.
          </p>
          <p className="mt-2 text-dark text-start">
            If you qualify for a refund under the Provider policy, refunds will
            be processed in accordance with that policy. Trivana Hospitality
            will endeavour to assist, but is not responsible for delays caused
            by Providers or payment processors.
          </p>
        </section>

        <section id="checkin" className="card p-4 mb-4 shadow-sm animate-fade">
          <div className="d-flex align-items-center mb-2">
            <span className="section-accent me-3"></span>
            <h2 className="card-title h4 mb-0 fw-bold">
              6. Check-in, Check-out &amp; No-shows
            </h2>
          </div>
          <p className="text-dark text-start">
            Check-in/check-out times and identification requirements are set by
            the Provider. It is your responsibility to check Provider policies
            (e.g., valid ID, deposit). Failure to show up (no-show) may lead to
            cancellation and forfeiture of payment according to the applicable
            Provider policy.
          </p>
        </section>

        <section
          id="user-responsibilities"
          className="card p-4 mb-4 shadow-sm animate-fade"
        >
          <div className="d-flex align-items-center mb-2">
            <span className="section-accent me-3"></span>
            <h2 className="card-title h4 mb-0 fw-bold">
              7. User Responsibilities &amp; Conduct
            </h2>
          </div>
          <ul className="mt-2 text-dark text-start">
            <li>
              Users must provide accurate contact and payment information.
            </li>
            <li>
              Users must comply with Provider rules and local laws while using
              accommodations or services.
            </li>
            <li>
              Any abusive, fraudulent or illegal conduct may result in
              cancellation and/or legal action.
            </li>
          </ul>
        </section>

        <section
          id="changes-providers"
          className="card p-4 mb-4 shadow-sm animate-fade"
        >
          <div className="d-flex align-items-center mb-2">
            <span className="section-accent me-3"></span>
            <h2 className="card-title h4 mb-0 fw-bold">
              8. Changes by Providers or Trivana
            </h2>
          </div>
          <p className="text-dark text-start">
            Providers may change or cancel bookings due to unforeseen
            circumstances. If a Provider makes a material change, we will
            attempt to notify you and help you secure alternative arrangements.
            Trivana Hospitality reserves the right to modify or suspend the
            Website or its services at any time.
          </p>
        </section>

        <section
          id="liability"
          className="card p-4 mb-4 shadow-sm animate-fade"
        >
          <div className="d-flex align-items-center mb-2">
            <span className="section-accent me-3"></span>
            <h2 className="card-title h4 mb-0 fw-bold">
              9. Liability &amp; Indemnity
            </h2>
          </div>
          <p className="text-dark text-start">
            Trivana Hospitality acts as an intermediary platform that connects
            Users with Providers. We do not own or operate the hotels,
            restaurants or services listed. We are not responsible for the acts
            or omissions of Providers, including service quality, injuries,
            losses or other claims arising from Provider services.
          </p>
          <p className="mt-2 text-dark text-start">
            To the fullest extent permitted by law, our liability to you for any
            direct loss is limited to the greater of (a) the value of the
            booking fee collected by us in respect of the relevant booking, or
            (b) INR 5,000. We are not liable for any indirect, incidental,
            special or consequential losses.
          </p>
        </section>

        <section id="privacy" className="card p-4 mb-4 shadow-sm animate-fade">
          <div className="d-flex align-items-center mb-2">
            <span className="section-accent me-3"></span>
            <h2 className="card-title h4 mb-0 fw-bold">
              10. Privacy &amp; Data Protection
            </h2>
          </div>
          <p className="text-dark text-start">
            We process your personal information in accordance with our{" "}
            <a href="/privacy-policy" className="contact-link">
              Privacy Policy
            </a>
            . By using our services you consent to the collection, processing
            and transfer of your information as described in that policy.
          </p>
        </section>

        <section
          id="governing-law"
          className="card p-4 mb-4 shadow-sm animate-fade"
        >
          <div className="d-flex align-items-center mb-2">
            <span className="section-accent me-3"></span>
            <h2 className="card-title h4 mb-0 fw-bold">
              11. Governing Law &amp; Dispute Resolution
            </h2>
          </div>
          <p className="text-dark text-start">
            These Terms are governed by the laws of India. Any disputes arising
            from or in connection with these Terms shall be subject to the
            exclusive jurisdiction of the courts of New Delhi, India, unless
            otherwise required by mandatory law.
          </p>
        </section>

        <section id="contact" className="card p-4 mb-4 shadow-sm animate-fade">
          <div className="d-flex align-items-center mb-2">
            <span className="section-accent me-3"></span>
            <h2 className="card-title h4 mb-0 fw-bold">
              12. Contact &amp; Support
            </h2>
          </div>
          <p className="text-dark text-start">
            If you have questions about these Terms or need support with a
            booking, please contact our support team:
          </p>
          <p className="mt-2 text-dark text-start">
            <strong>Trivana Hospitality (Booktrivana)</strong>
            <br />
            Email:{" "}
            <a className="contact-link" href="mailto:booktrivana@gmail.com">
              booktrivana@gmail.com
            </a>
            <br />
            Phone: +91 9257734350 (support hours apply)
          </p>

          <p className="mt-3 text-muted text-start">
            Notes: These Terms may be updated periodically. We will post changes
            on this page; continued use after changes constitutes acceptance.
          </p>
        </section>
      </div>

      {/* Custom CSS for features not in Bootstrap */}
      <style>{`
        /* Global & overflow fixes (RESPO PROBLEM safe) */
        html,
        body {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
          font-family: "Inter", system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial;
          -webkit-font-smoothing: antialiased;
          -moz-osx-font-smoothing: grayscale;
          overflow-x: hidden;
          scroll-behavior: smooth;
        }

        *,
        *::before,
        *::after {
          box-sizing: inherit;
        }

        /* Page wrapper & background */
        .terms-wrapper {
          min-height: 100vh;
          width: 100%;
          background: linear-gradient(180deg, #ffffff 0%, #f5f5f5 100%);
          overflow-x: hidden;
        }

        /* Animated gradient heading (Trivana theme) */
        .header-title {
          font-size: clamp(22px, 3.4vw, 40px);
          font-weight: 800;
          line-height: 1.05;
          margin: 0 0 8px 0;
          background: linear-gradient(90deg, #EE2E24, #FFC400, #EE2E24);
          -webkit-background-clip: text;
          background-clip: text;
          color: transparent;
          display: inline-block;
          animation: slideInFromTop 600ms ease both;
        }

        .subhead {
          color: #475569;
          font-size: clamp(14px, 1.6vw, 18px);
          margin: 0 auto;
          max-width: 900px;
        }
        
        /* Card hover animation */
        .card {
          transition: transform 0.3s ease, box-shadow 0.3s ease;
        }

        .card:hover {
          transform: translateY(-6px);
          box-shadow: 0 18px 40px rgba(14, 30, 37, 0.08);
        }

        /* Section headings inside cards */
        .section-accent {
          width: 6px;
          height: 26px;
          border-radius: 4px;
          background: linear-gradient(180deg, #EE2E24, #FFC400);
          flex-shrink: 0;
        }
        
        /* Table of contents and contact links */
        .toc-link,
        .contact-link {
          color: #0f172a; /* Default link color */
          font-weight: 600;
          text-decoration: none;
          transition: color 0.2s ease;
        }
        
        .toc-link:hover,
        .contact-link:hover {
          color: #EE2E24; /* Brand hover color */
          text-decoration: underline;
        }

        /* small utilities and responsive fixes */
        .muted {
          color: #6b7280;
        }

        /* anchor offset for sticky headers if any */
        :target {
          scroll-margin-top: 90px;
        }

        /* Animations */
        @keyframes slideInFromTop {
          from {
            opacity: 0;
            transform: translateY(-12px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        @keyframes fadeUp {
          from {
            opacity: 0;
            transform: translateY(10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        .animate-fade {
          animation: fadeUp 600ms ease both;
        }
        `}</style>
    </div>
  );
};

export default TermsConditions;
